import { Carousel } from 'react-responsive-carousel';
import { P } from '../../../../../../AbstractElements';
import CommonFileUpload from '../../../../../Common/CommonFileUpload';
import ProductGallery from './ProductGallery';

const ProductTwo = ({ images, setUploadFiles }: { images?: string[]; setUploadFiles: any }) => {
    return (
        <div className="sidebar-body">
            <div className="product-upload">
                <P>Product Image </P>
                <CommonFileUpload
                    multiple
                    handleSetUploadedFiles={setUploadFiles}
                />
            </div>
            {images && images.length > 0 && (
                <Carousel
                    className="owl-carousel owl-theme"
                    showStatus={false}
                    showIndicators={false}
                    showArrows={false}
                    swipeable={true}
                    autoPlay={true}
                    infiniteLoop={true}>
                    {images.map((item, index) => {
                        return (
                            <div className="item">
                                <img
                                    src={item}
                                    alt=""
                                />
                            </div>
                        );
                    })}
                </Carousel>
            )}
        </div>
    );
};

export default ProductTwo;
